import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { Info } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { GetCustomPolicyDto, GetCustomResponse } from "@/types/api/api-types";
import { CustomPolicySectionCard } from "./customPolicySectionCard";
import { memo } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  custom: GetCustomResponse;
  policy: GetCustomPolicyDto;
};

const CustomPolicyDetailsCard = ({ custom, policy }: Props) => {
  const { t } = useTranslation("boCustoms");
  return (
    <div className="w-80 shrink-0">
      <div className="sticky top-0">
        <CustomPolicySectionCard icon={Info} title={t("policyDetails.title")}>
          <Separator />
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-1">
              <span className="text-xs font-medium text-gray-500">
                {t("policyDetails.updatedAtLabel")}
              </span>
              <span className="text-sm font-medium text-gray-900">
                {format(new Date(policy.updatedAt), "dd/MM/yyyy 'à' HH:mm", { locale: fr })}
              </span>
            </div>

            <Separator />

            <div className="flex flex-col gap-2">
              <span className="text-xs font-medium text-gray-500">
                {t("policyDetails.countryLabel")}
              </span>
              <div className="flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2">
                {custom.flagCode && (
                  <img
                    src={`http://purecatamphetamine.github.io/country-flag-icons/3x2/${custom.flagCode.toUpperCase()}.svg`}
                    className="h-4 w-6 rounded-sm object-cover"
                    alt={custom.label}
                  />
                )}
                <span className="text-sm font-medium">{custom.label}</span>
              </div>
            </div>
          </div>
        </CustomPolicySectionCard>
      </div>
    </div>
  );
};

export const MemoizedCustomPolicyDetailsCard = memo(
  CustomPolicyDetailsCard,
  (prevProps, nextProps) => {
    return (
      prevProps.custom.id === nextProps.custom.id && prevProps.policy.id === nextProps.policy.id
    );
  },
);
